import React from 'react';

const PrebookCard = () => {
  return (
    <div className="flex items-center justify-center px-4 py-10">
      <div className="font-sans relative w-full max-w-[1176px] rounded-[24px] bg-[#F2FBF7] px-6 py-[48px] text-center md:rounded-[48px] md:px-[64px]">
        {/* Heading */}
        <h2 className="mb-4 font-manrope text-[24px] font-extrabold capitalize leading-[30px] text-[#000000] md:text-[48px] md:leading-[54px]">
          Why Prebook?
        </h2>

        {/* Scholarship Info */}
        <p className="mb-8 font-rubik text-[12px] font-normal leading-[20px] text-[#7A8B87] md:text-[20px] md:leading-[36px]">
          You’ve been granted scholarship benefits worth up to{' '}
          <span className="font-bold">₹50,000.</span>
        </p>

        {/* Subheading */}
        <h3 className="mb-6 font-manrope text-[18px] font-extrabold capitalize leading-[30px] text-[#000000] md:text-[24px] md:leading-[34px]">
          To Avail:
        </h3>

        {/* Green Blocks */}
        <div className="relative flex flex-col items-center gap-6">
          {/* First Green Block */}
          <div className="flex h-auto w-full max-w-[734px] items-center justify-center rounded-[8px] bg-[#54f2bd] px-4 py-3 text-center text-[#000000] shadow-[10px_10px_10px_0px_#0000000D] md:h-[66px] md:rounded-[20px]">
            <p className="font-rubik text-[12px] font-normal leading-[15px] md:text-[20px] md:leading-[36px]">
              You can either make the{' '}
              <span className="font-bold">full payment</span> now and confirm
              your enrollment
            </p>
          </div>

          {/* OR Circle */}
          <div className="absolute top-1/2 left-1/2 z-10 flex h-[30px] w-[30px] -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-[#E6F4F2] shadow-md md:h-[48px] md:w-[48px]">
            <span className="font-manrope text-[12px] font-extrabold leading-[34px] text-[#000000] md:text-[24px]">
              or
            </span>
          </div>

          {/* Second Green Block */}
          <div className="flex h-auto w-full max-w-[734px] items-center justify-center rounded-[8px] bg-[#54f2bd] px-4 py-3 text-center text-[#000000] shadow-[10px_10px_10px_0px_#0000000D] md:h-[66px] md:rounded-[20px]">
            <p className="font-rubik text-[12px] font-normal leading-[15px] md:text-[20px] md:leading-[36px]">
              Simply pay <span className="font-bold">₹1000</span> to
              provisionally enroll and reserve your scholarship seat
            </p>
          </div>
        </div>

        {/* Footer Text */}
        <div className="mx-auto mt-8 w-full max-w-[734px] px-4">
          <p className="text-center font-rubik text-[12px] font-normal leading-[20px] text-[#7A8B87] md:text-[20px] md:leading-[36px]">
            This ensures your benefits are locked in while you take the time to
            decide.
            <br />
            Prebook now and enroll when you're ready.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrebookCard;
